module.exports = __webpack_public_path__ + "img/my-settings.94223a35.png";